import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";
import { hasValue, SHA512 } from "../../../utils/functions.js";

export default {
  name: "Transaction",
  components: {
    dateField,
    decimalField
  },
  data() {
    return {
      countFilter: 0,
      BankList: [],
      BankData: {
        Bank: {
          Code: null
        },
        AccountType: {
          Code: null
        },
        BankAgency: "",
        BankAgencyDigit: "",
        BankAccount: "",
        BankAccountDigit: ""
      },
      disabledDatesCreatedMax: new Date(),
      disabledDatesCreatedMin: new Date(),
      disabledDatesPaymentMax: new Date(),
      disabledDatesPaymentMin: new Date(),
      initialDate: new Date(),
      Columns: {
        Id: true,
        Merchant: true,
        Customer: true,
        Reference: true,
        PaymentMethod: true,
        Application: true,
        Canal:true,
        Amount: true,
        Vendor: false,
        Status: true,
        PaymentDate: true,
        Subaccount: false,
        NomeCanal: true
      },
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      loading: false,
      loadingCreateUpdate: false,
      loadingDownload: false,
      loadingTransaction: false,
      loadingReport: false,
      validatedBankData: false,
      loadingReportProfit: false,
      loadingResendEmail: false,
      loadingResendTechEmail: false,
      loadingContract: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      filter: this.FilterDefault(),
      idtransactions: 0,
      transactions: [],
      infoTransaction: this.InfoTransactionDefault(),
      relatedTransactions: this.relatedTransactions,
      isSeeing: false,
      modalTitle: "Novo cliente",
      mSteps: ["Cliente", "Pagamento", "Produto", "Histórico", "Splits", "Informações Adicionais", "Correlações", "Dados do Merchant"],
      transactionStatus: [],
      idMerchant: null,
      paymentMethods: [],
      subcontas: [],
      mCurrentStep: 0,
      previousPageinfo: [],
      redirectOpen: false,
      tableKey: 0,
      taxPaymentMethod: null,
      ticketsTableKey: 0,
      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedTaxForm: false,
      validatedTechStep: false,
      selected_payment: null,
      validatedFormValidation: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  watch: {
    "pagination.PageNumber"() {
      this.ListTransaction();
    },
    "pagination.RowsPerPage"() {
      this.ListTransaction();
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.ListTransactionStatus();
    this.ListPaymentMethod();
    this.GetClass();
    this.GetBanks();
  },
  methods: {
    GetBanks() {
      this.$store
        .dispatch("GetBanks")
        .then(response => {
          this.BankList = response;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível carregar a lista de bancos, tente novamente.",
            "danger",
            "Falha ao obter a lista de bancos",
            error
          );
        });
    },
    GetClass() {
      if (this.infoTransaction != null && this.infoTransaction.Id > 0) {
        switch (this.infoTransaction.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
          case "19":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
          case "18":  
            return "labelModal labeldanger";
        }
      }
    },
    OpenModalTransaction(i) {
      this.mCurrentStep = 0;
      this.ResetinfoTransaction();

      // View
      this.idTransaction = this.transactions[i].Id;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetTransaction(this.idTransaction, this.transactions[i].Merchant.Id);
      this.$bvModal.show("mFormTransaction");
    },
    ChangeGet(idTransaction, idMerchant) {
      this.mCurrentStep = 0;
      this.ResetinfoTransaction();

      // View
      this.idTransaction = idTransaction;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetTransaction(this.idTransaction, idMerchant);
    },
    ColumnsConfigChanged() {
      sessionStorage.setItem("Columns", JSON.stringify(this.Columns));
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.validatedFormValidation = true;
      this.$refs.ValidationForm.validate().then(isValid => {
        if (isValid && this.ValidateFilter()) {
          this.$bvModal.hide("mFilter");
          this.ListTransaction();
        }
      });
    },
    ResetFilter() {
      this.filter = this.FilterDefault();
      this.countFilter = 0;
      this.transactions = [];
      this.pagination.TotalItems = 0;
    },
    FilterDefault(){
      return {
        TransactionId: null,
        MerchantEmail: null,
        CustomerName: null,
        CustomerIdentity: null,
        CustomerEmail: null,
        Reference: null,
        TransactionAmount: null,
        Bin: null,
        Last4: null,
        DigitableLine: null,
        Barcode: null,
        EndToEnd: null,
        AuthorizationCode: null,
        IdCanal: null
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ListTransaction() {
      if(this.ValidateFilter()){
        this.loading = true;
        let params = this.GetParamsData();
        this.$store
          .dispatch("ListTransactionsDirectly", { params: params })
          .then(response => {
            this.transactions = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          })
          .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações", error))
          .finally(() => this.loading = false);
      }
    },
    GetParamsData(deletePagination = false) {
      var columns = [];

      if (deletePagination){
        if (Object.keys(this.Columns).length > 0) {
          for (let key in this.Columns) {
            var keyValue = this.Columns[key];
            if (keyValue != null && keyValue != "undefined") {
              if (keyValue == true) columns.push(key);
            }
          }
        }
      }

      const regExp = new RegExp(/[\D]/g);
      const cleanedDigitableLine = hasValue(this.filter.DigitableLine) ? this.filter.DigitableLine.replace(regExp, '') : null;
      const cleanedBarcode = hasValue(this.filter.Barcode) ? this.filter.Barcode.replace(regExp, '') : null;

      let data = {
        ...this.pagination,
        ColumnsFilter: columns,
        "TransactionId": this.filter.TransactionId,
        "MerchantEmail": this.filter.MerchantEmail,
        "CustomerName": this.filter.CustomerName,
        "CustomerIdentity": this.filter.CustomerIdentity,
        "CustomerEmail": this.filter.CustomerEmail,
        "Reference": this.filter.Reference,
        "TransactionAmount": this.filter.TransactionAmount,
        "Bin": this.filter.Bin,
        "Last4": this.filter.Last4,
        "DigitableLine": cleanedDigitableLine,
        "Barcode": cleanedBarcode,
        "EndToEndId": this.filter.EndToEnd,
        "AuthorizationCode": this.filter.AuthorizationCode,
        "IdCanal": this.filter.IdCanal
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ValidateFilter(isReport = false){
      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });

      let retorno = true;
      if((this.filter.Bin || this.filter.Last4) && (this.filter.DigitableLine || this.filter.Barcode)){
        this.$makeToast("Não se pode ter filtros de metódos de pagamentos diferentes", "danger", "Filtros se contradizem");
        retorno = false;
      }

      if(isReport){
        if(this.countFilter == 0){
          this.$makeToast("Filtro não pode estar vazio", "danger", "Filtro vazio");
          retorno = false;
        }
        if(this.filter.Bin && this.filter.Bin.toString().length != 6){
          this.$makeToast("Os 6 primeiros dígitos, tem que ter 6 dígitos", "danger", "Faltam dígitos");
          retorno = false;
        }
        if(this.filter.Last4 && this.filter.Last4.toString().length != 4){
          this.$makeToast("Os 4 ultimos dígitos, tem que ter 4 dígitos", "danger", "Faltam dígitos");
        }
        if(this.filter.DigitableLine && (this.filter.DigitableLine.toString().length != 47)){
          this.$makeToast("Linha digitada deve ter 47 dígitos", "danger", "Faltam dígitos");
          retorno = false;
        }
        if(this.filter.Barcode && this.filter.Barcode.toString().length != 44){
          this.$makeToast("Código de barras deve ter 44 dígitos", "danger", "Faltam dígitos");
          retorno = false;
        }
        if(this.filter.TransactionAmount != null && this.filter.TransactionAmount != undefined && this.filter.TransactionAmount < 0.01){
          this.$makeToast("O valor da transação deve ser maior que 0", "danger", "Valor inválido");
          retorno = false;
        }
      }

      return retorno;
    },
    ResetInfoBankData() {
      this.BankData = {
        Bank: {
          Code: null
        },
        AccountType: {
          Code: null
        },
        BankAgency: "",
        BankAgencyDigit: "",
        BankAccount: "",
        BankAccountDigit: ""
      };
    },
    InfoTransactionDefault() {
      return {
        Id: 0,
        Reference: null,
        Vendor: null,
        Application: null,
        IdCanal:null,
        Merchant:{
          Id: null
        },
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
              Initials: null
            },
            State: {
              Initials: null
            }
          }
        },
        PaymentMethod: {
          Code: null,
          BankSlipNumber: null,
          DueDate: null,
          InstallmentQuantity: null
        },
        PaymentObject: {
          Symbol: null,
          Brand: {
            Code: null
          },
          Amount: null,
          Address: null,
          Provider: null,
          AdditionPayment: null,
          DiscountPayment: null,
          QrCode: null,
          BankData: {
            BankAgency: null,
            BankAgencyDigit: null,
            BankAccount: null,
            BankAccountDigit: null,
            Bank: {
              Name: null
            }
          }
        },
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        CheckingAccounts: [],
        Splits: [],
        History: [],
        IsSplitter: false,
        Products: [],
        Plan: {
          Name: null
        },
        TransactionStatus: {
          Code: "1"
        },
        Merchant: {
          Name: null,
          Documents: null,
        },
      }
    },
    ResetinfoTransaction() {
      this.mCurrentStep = 0;
      this.idTransaction = 0;
      this.infoTransaction = this.InfoTransactionDefault();
    },
    GetTransaction(id, idMerchant) {
      this.loadingTransaction = true;
      this.$store
        .dispatch("GetTransaction", { id: id, idMerchant: idMerchant })
        .then(response => {
          this.infoTransaction = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.loadingTransaction = false;
        });
    },
    HideModal() {
      this.$bvModal.hide("mFormTransaction");
    },
    ProcessNextStep(nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
    },
    NextStep() {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        if (this.mCurrentStep == 3 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep += 2;
        } else this.mCurrentStep += 1;
      }
    },
    BackStep() {
      if (this.mCurrentStep >= 1) {
        if (this.mCurrentStep == 5 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep -= 2;
        } else this.mCurrentStep -= 1;
      }
    },
    GoToStep(e, stepToGo) {
      e.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    ListTransactionStatus() {
      this.$store
        .dispatch("ListTransactionStatus", {})
        .then(response => {
          this.transactionStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de status", error);
        });
    },
    ListCreditCardRefused() {
      const todayDate = new Date().toISOString().slice(0, 10);
      const lastMonth = new Date(todayDate);
      lastMonth.setMonth(lastMonth.getMonth() -1);
      this.loadingTransactionRelated = true;
      this.$store
        .dispatch("ListCreditCardRefused", { "Object.Customer.Identity": this.infoTransaction.Customer.Identity, "CreatedDateInitial": lastMonth })
        .then(response => {
          this.relatedTransactions = response.Objects;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações relacionadas", error))
        .finally(() => {
          this.loadingTransactionRelated = false;
        });
    },
    ListPaymentMethod() {
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de pagamento", error);
        });
    },
    previousPage() {
      const qs = require("qs");
      const prev = qs.parse(this.previousPageinfo);
      const component = prev.component;
      delete prev.component;

      this.$router.push({
        name: component,
        query: {
          previous: qs.stringify(prev)
        }
      });
    },
    GetReport(ev) {
      ev.preventDefault();

      if(this.ValidateFilter(true)){
        this.loadingReport = true;
        let data = this.GetParamsData(true);
        this.$store
          .dispatch("ReportTransactionDirectly", { params: data })
          .then(response => {
            if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
              this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
              window.open(response.UrlReport, "_self");
            }
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
          })
          .finally(() => {
            $("#dropTableOptions").dropdown("hide");
            setTimeout(() => {
              this.loadingReport = false;
            }, 1200);
          });
      }
    },
    ComputeExpirationPix(CreatedDate, Expiration){
      const expirationDate = new Date(CreatedDate);
      expirationDate.setSeconds(expirationDate.getSeconds() + Expiration);
      return expirationDate;
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/Transaction/Transaction.js